<template>
  <div :class="[options.textSizeClass]">
    کد پرسنلی: {{ personalCode }}
  </div>
</template>

<script>
  import { get } from 'vuex-pathify'

  export default {
    name: 'DefaultAccount',
    props: {
      options: {
        type: Object,
        default: () => { return { textSizeClass: 'text-h6' } },
      },
    },
    data: () => ({}),
    computed: {
      ...get('auth', [
        'getCurrentUser',
      ]),
      personalCode () {
        var user = this.getCurrentUser
        if (user && user.userData) { return `${user.userData.personalCode}` }
        return ''
      },
    },
  }
</script>
